<template>
  <div class="model-block">
    <div v-if="loading" class="loading">
      <div class="loading-spinner"></div>
      <p>处理中...</p>
    </div>
    <div v-else class="result">
      <div v-if="unblocked" class="success">Key 已成功解锁</div>
      <div v-else class="error">Key解锁失败，请检查您的账户余额是否充足，如有问题请联系客服</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { gotoLogin, token } from '@/utils'
import axios from '@/axios'

const loading = ref(false)
const unblocked = ref(false)

onMounted(async () => {
  // 检查是否有token
  if (!token()) {
    gotoLogin()
    return
  }

  // 调用接口
  loading.value = true
  try {
    const response = await axios.request<{ unblocked: boolean }>({
      url: '/ai-gateway-management/api/v2/unblock',
    })
    unblocked.value = response.unblocked
  } catch (error) {
    unblocked.value = false
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.model-block {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #1890ff;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.result {
  font-size: 24px;
  font-weight: bold;
  padding: 40px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.success {
  color: #52c41a;
}

.error {
  color: #ff4d4f;
}
</style>
